define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/GrazingAuthPermit", "../entity/TravelPermit", "../entity/StockSchedule", "../entity/PermitLandtype", "../entity/GrazingPermit", "../entity/PermitDoc", "../entity/PermitLicItem", "../entity/HarvestingPermit", "lodash.debounce", "../../store/Events", "../../utils/MathUtil", "../domain", "../services", "../services/EventManager", "./PermitLicenseModel"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, GrazingAuthPermit_1, TravelPermit_1, StockSchedule_1, PermitLandtype_1, GrazingPermit_1, PermitDoc_1, PermitLicItem_1, HarvestingPermit_1, lodash_debounce_1, Events_1, MathUtil_1, domain_1, services_1, EventManager_1, PermitLicenseModel_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Permit = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    class Permit extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicationId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicationIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ParentId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ParentIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AncestorId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AncestorIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConfigId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConfigIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lga", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatusReq", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatusReqError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatusPrev", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatusPrevError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatusDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatusDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeApplicationRule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeApplicationRuleError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeApplication", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeApplicationError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePermitRule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePermitRuleError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePermit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePermitError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeTotal", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeTotalError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeStateGov", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeStateGovError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalFeeTotal", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalFeeTotalError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalFeeStateGov", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalFeeStateGovError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CommentAppDecision", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CommentAppDecisionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CommentAdditionalCond", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CommentAdditionalCondError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrnSegments", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrnSegmentsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingAuthPermit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingAuthPermitError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelPermit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelPermitError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockSchedule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedStockSchedule", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockScheduleError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitLandtype", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedPermitLandtype", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitLandtypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingPermit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingPermitError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedPermitDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitDocError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitLicItem", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedPermitLicItem", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitLicItemError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HarvestingPermit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HarvestingPermitError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitApplication", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "License", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ParentPermit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsFeePerHeadPerWeekPropertyRequired", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePerHeadPerWeekForLargeStockMinValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePerHeadPerWeekForLargeStockMaxValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePerHeadPerWeekForLargeStockBatchSize", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePerHeadPerWeekForSmallStockMinValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePerHeadPerWeekForSmallStockMaxValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePerHeadPerWeekForSmallStockBatchSize", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, Permit.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PermitApplication = parent;
            this.ApplicationId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.GrazingAuthPermit = null;
            this.TravelPermit = null;
            this.StockSchedule = [];
            this.PermitLandtype = [];
            this.GrazingPermit = null;
            this.PermitDoc = [];
            this.PermitLicItem = [];
            this.HarvestingPermit = null;
        }
        onRead(entity, parent) {
            this.PermitApplication = parent;
            this.StockSchedule = [];
            this.PermitLandtype = [];
            this.PermitDoc = [];
            this.PermitLicItem = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.RefId = b.RefId;
            a.ApplicationId = (0, EntityUtil_1.toInt)(entity.ApplicationId);
            a.ParentId = (0, EntityUtil_1.toInt)(entity.ParentId);
            a.AncestorId = (0, EntityUtil_1.toInt)(entity.AncestorId);
            a.ConfigId = (0, EntityUtil_1.toInt)(entity.ConfigId);
            a.SystemState = (0, EntityUtil_1.toInt)(entity.SystemState);
            a.PermitType = (0, EntityUtil_1.toInt)(entity.PermitType);
            a.Lga = b.Lga;
            a.LgaCode = b.LgaCode;
            a.LicenseStatus = b.LicenseStatus;
            a.LicenseStatusReq = b.LicenseStatusReq;
            a.LicenseStatusPrev = b.LicenseStatusPrev;
            a.LicenseStatusDate = b.LicenseStatusDate;
            a.FeeApplicationRule = (0, EntityUtil_1.toInt)(entity.FeeApplicationRule);
            a.FeeApplication = (0, EntityUtil_1.toFloat)(entity.FeeApplication);
            a.FeePermitRule = (0, EntityUtil_1.toInt)(entity.FeePermitRule);
            a.FeePermit = (0, EntityUtil_1.toFloat)(entity.FeePermit);
            a.FeeTotal = (0, EntityUtil_1.toFloat)(entity.FeeTotal);
            a.FeeStateGov = (0, EntityUtil_1.toFloat)(entity.FeeStateGov);
            a.FinalFeeTotal = (0, EntityUtil_1.toFloat)(entity.FinalFeeTotal);
            a.FinalFeeStateGov = (0, EntityUtil_1.toFloat)(entity.FinalFeeStateGov);
            a.CommentAppDecision = b.CommentAppDecision;
            a.CommentAdditionalCond = b.CommentAdditionalCond;
            a.SrnSegments = b.SrnSegments;
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.GrazingAuthPermit = this.mergeObject(a.GrazingAuthPermit, b.GrazingAuthPermit, GrazingAuthPermit_1.GrazingAuthPermit);
            a.TravelPermit = this.mergeObject(a.TravelPermit, b.TravelPermit, TravelPermit_1.TravelPermit);
            a.StockSchedule = this.mergeArray(a.StockSchedule, b.StockSchedule, StockSchedule_1.StockSchedule);
            a.SelectedStockSchedule = a.SelectedStockSchedule && a.StockSchedule.find(x => x.Id == a.SelectedStockSchedule.Id) ? a.SelectedStockSchedule : null;
            a.PermitLandtype = this.mergeArray(a.PermitLandtype, b.PermitLandtype, PermitLandtype_1.PermitLandtype);
            a.SelectedPermitLandtype = a.SelectedPermitLandtype && a.PermitLandtype.find(x => x.Id == a.SelectedPermitLandtype.Id) ? a.SelectedPermitLandtype : null;
            a.GrazingPermit = this.mergeObject(a.GrazingPermit, b.GrazingPermit, GrazingPermit_1.GrazingPermit);
            a.PermitDoc = this.mergeArray(a.PermitDoc, b.PermitDoc, PermitDoc_1.PermitDoc);
            a.SelectedPermitDoc = a.SelectedPermitDoc && a.PermitDoc.find(x => x.Id == a.SelectedPermitDoc.Id) ? a.SelectedPermitDoc : null;
            a.PermitLicItem = this.mergeArray(a.PermitLicItem, b.PermitLicItem, PermitLicItem_1.PermitLicItem);
            a.SelectedPermitLicItem = a.SelectedPermitLicItem && a.PermitLicItem.find(x => x.Id == a.SelectedPermitLicItem.Id) ? a.SelectedPermitLicItem : null;
            a.HarvestingPermit = this.mergeObject(a.HarvestingPermit, b.HarvestingPermit, HarvestingPermit_1.HarvestingPermit);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
            if (this.License) {
                this.License.loadLicenseItems();
            }
        }
        onReady() {
            this.License = new PermitLicenseModel_1.PermitLicenseModel(this);
            this.addChangeEventAction("LicenseStatus", this.License.evaluateStatus.bind(this.License));
            this.addChangeEventAction("LicenseStatusPrev", this.License.evaluateStatus.bind(this.License));
            for (let p of this.PermitApplication.Permit) {
                if (p.Id == this.ParentId && p.SystemState == domain_1.EntitySysStatusDomain.Active) {
                    this.ParentPermit = p;
                    break;
                }
            }
            if (this.PermitApplication) {
                this.addChangeEventAction("FeeTotal", this.PermitApplication.calculatePermitFees.bind(this.PermitApplication));
                this.addChangeEventAction("FeeStateGov", this.PermitApplication.calculatePermitFees.bind(this.PermitApplication));
                this.addChangeEventAction("FinalFeeTotal", this.PermitApplication.calculatePermitFees.bind(this.PermitApplication));
                this.addChangeEventAction("FinalFeeStateGov", this.PermitApplication.calculatePermitFees.bind(this.PermitApplication));
            }
            if (this.PermitType == domain_1.PermitTypeDomain.TravelPermit) {
                this.TravelPermit.addChangeEventAction("TravelType", this.License.updateLicenseItems.bind(this.License));
            }
            else if (this.PermitType == domain_1.PermitTypeDomain.GrazingPermit) {
                this.GrazingPermit.addChangeEventAction("GrazingType", this.License.updateLicenseItems.bind(this.License));
                this.IsFeePerHeadPerWeekPropertyRequired = true;
                this.getStockMinMaxValues();
                const onStartDtChange = (0, lodash_debounce_1.default)(this.getStockMinMaxValues, 500);
                this.GrazingPermit.addChangeEventAction("FinalStartDt", onStartDtChange.bind(this));
                this.GrazingPermit.addChangeEventAction("StartDt", onStartDtChange.bind(this));
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, Permit.AliasName);
            this.reset();
            this._validate(validationState);
            if (!this.IsMarkedForDeletion && this.IsActive && this.License.IsPendingApprovalOrApproved) {
                if (this.PermitType == domain_1.PermitTypeDomain.TravelPermit || this.PermitType == domain_1.PermitTypeDomain.GrazingPermit) {
                    if (this.StockSchedule == null || this.StockSchedule.length == 0) {
                        this.StockScheduleError = "A Stock Schedule must be specified";
                        validationState.addError(this.StockScheduleError);
                    }
                    else {
                        this.StockScheduleError = "";
                    }
                }
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "Permit ID");
                this.validateReqString(validationState, "RefId", "Reference Permit ID");
                this.validateReqNumber(validationState, "ApplicationId", "Permit Application ID");
                this.validateReqNumber(validationState, "ConfigId", "Configuration Id");
                this.validateReqNumber(validationState, "SystemState", "System State");
                this.validateReqString(validationState, "LgaCode", "LGA Code");
                this.validateReqNumber(validationState, "FeeApplicationRule", "Application Fee Rule");
                this.validateReqNumber(validationState, "FeeApplication", "Application Fee", { precision: 2 });
                this.validateReqNumber(validationState, "FeePermitRule", "Permit Fee Rule");
                this.validateReqNumber(validationState, "FeePermit", "Permit Fee", { precision: 2 });
                this.validateReqNumber(validationState, "FeeTotal", "Total Fee", { precision: 2 });
                this.validateReqNumber(validationState, "FeeStateGov", "Fee Due to State Government", { precision: 2 });
                this.validateReqNumber(validationState, "FinalFeeTotal", "Total Fee (Actual)", { precision: 2 });
                this.validateReqNumber(validationState, "FinalFeeStateGov", "Fee Due to State Government (Actual)", { precision: 2 });
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.GrazingAuthPermit) {
                this.GrazingAuthPermit.walk(func, { leading });
            }
            if (this.TravelPermit) {
                this.TravelPermit.walk(func, { leading });
            }
            if (this.StockSchedule) {
                for (let x of this.StockSchedule) {
                    x.walk(func, { leading });
                }
            }
            if (this.PermitLandtype) {
                for (let x of this.PermitLandtype) {
                    x.walk(func, { leading });
                }
            }
            if (this.GrazingPermit) {
                this.GrazingPermit.walk(func, { leading });
            }
            if (this.PermitDoc) {
                for (let x of this.PermitDoc) {
                    x.walk(func, { leading });
                }
            }
            if (this.PermitLicItem) {
                for (let x of this.PermitLicItem) {
                    x.walk(func, { leading });
                }
            }
            if (this.HarvestingPermit) {
                this.HarvestingPermit.walk(func, { leading });
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                RefId: this.RefId,
                ApplicationId: this.ApplicationId,
                ParentId: this.ParentId,
                AncestorId: this.AncestorId,
                ConfigId: this.ConfigId,
                SystemState: this.SystemState,
                PermitType: this.PermitType,
                Lga: this.Lga,
                LgaCode: this.LgaCode,
                LicenseStatus: this.LicenseStatus,
                LicenseStatusReq: this.LicenseStatusReq,
                LicenseStatusPrev: this.LicenseStatusPrev,
                LicenseStatusDate: this.LicenseStatusDate,
                FeeApplicationRule: this.FeeApplicationRule,
                FeeApplication: this.FeeApplication,
                FeePermitRule: this.FeePermitRule,
                FeePermit: this.FeePermit,
                FeeTotal: this.FeeTotal,
                FeeStateGov: this.FeeStateGov,
                FinalFeeTotal: this.FinalFeeTotal,
                FinalFeeStateGov: this.FinalFeeStateGov,
                CommentAppDecision: this.CommentAppDecision,
                CommentAdditionalCond: this.CommentAdditionalCond,
                SrnSegments: this.SrnSegments,
                AuditCreateUser: this.AuditCreateUser,
                AuditCreateDate: this.AuditCreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                GrazingAuthPermit: this.GrazingAuthPermit ? this.GrazingAuthPermit.toJson() : undefined,
                TravelPermit: this.TravelPermit ? this.TravelPermit.toJson() : undefined,
                StockSchedule: this.StockSchedule.map(x => x.toJson()),
                PermitLandtype: this.PermitLandtype.map(x => x.toJson()),
                GrazingPermit: this.GrazingPermit ? this.GrazingPermit.toJson() : undefined,
                PermitDoc: this.PermitDoc.map(x => x.toJson()),
                PermitLicItem: this.PermitLicItem.map(x => x.toJson()),
                HarvestingPermit: this.HarvestingPermit ? this.HarvestingPermit.toJson() : undefined,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get StatusValue() {
            var _a;
            let k = this.LicenseStatusReq ? this.LicenseStatusReq : this.LicenseStatus;
            let v = (_a = domain_1.PermitLicenseStatusDomain.findByKey(k)) === null || _a === void 0 ? void 0 : _a.value;
            return this.LicenseStatusReq ? `${v}*` : v;
        }
        get IsUserPriviledgedToEdit() {
            return this.SecurityAccessLevel == EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        get IsAmendmentModeActive() {
            return this.LicenseStatus != domain_1.PermitLicenseStatusDomain.Draft ? true : false;
        }
        get IsReadOnly() {
            return !this.IsUserPriviledgedToEdit || this.SystemState == domain_1.EntitySysStatusDomain.Archived || this.IsAmendmentModeActive;
        }
        get IsActive() {
            return this.SystemState == domain_1.EntitySysStatusDomain.Active;
        }
        get ApplicableDocumentTypes() {
            return services_1.AppConfigManager.InstanceSync.getDocumentTypesByPermit(this.PermitType, this.LicenseStatus);
        }
        openDocument(document) {
            services_1.SrmsServiceManager.Instance.PermitApplication.getPermitReport(document.Id);
        }
        requestTmrPermitApproval() {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Requesting TMR Approval");
                services_1.SrmsServiceManager.Instance.PermitApplication.requestTmrPermitApproval(this.toJson()).then(res => {
                    var validationState = new EntityValidationState_1.EntityValidationState(this.Id, Permit.AliasName);
                    validationState.addValidationResult(res);
                    services_1.EventManager.Instance.emit(Events_1.VALIDATION_UPDATE_EVENT, validationState);
                });
            });
        }
        updatePermitOnGeometryChange(geometry) {
            if (this.PermitType == domain_1.PermitTypeDomain.TravelPermit) {
                this.TravelPermit.Shape = geometry;
            }
            else if (this.PermitType == domain_1.PermitTypeDomain.GrazingAuthority) {
                this.GrazingAuthPermit.Shape = geometry;
            }
            else if (this.PermitType == domain_1.PermitTypeDomain.GrazingPermit) {
                this.GrazingPermit.Shape = geometry;
            }
            else if (this.PermitType == domain_1.PermitTypeDomain.HarvestingPermit) {
                this.HarvestingPermit.Shape = geometry;
            }
            else {
                throw new Error("Unsupported Permit Type");
            }
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Updating Permit");
                services_1.SrmsServiceManager.Instance.PermitApplication.updatePermitOnGeometryChange(this.toJson()).then(res => {
                    if (res) {
                        if (res.GeometryLengthKm != -1) {
                            if (this.PermitType == domain_1.PermitTypeDomain.TravelPermit) {
                                this.TravelPermit.TravelDistance = (0, MathUtil_1.round)(res.GeometryLengthKm, 2);
                            }
                        }
                        if (res.GeometryAreaHec != -1) {
                            if (this.PermitType == domain_1.PermitTypeDomain.GrazingAuthority) {
                                this.GrazingAuthPermit.IsWithinSrn = res.IsWithinSrn ? 1 : 0;
                                this.GrazingAuthPermit.GrazingArea = (0, MathUtil_1.round)(res.GeometryAreaHec, 2);
                                this.GrazingAuthPermit.GrazingAreaTotal = this.GrazingAuthPermit.GrazingArea - this.GrazingAuthPermit.GrazingAreaEx;
                            }
                            else if (this.PermitType == domain_1.PermitTypeDomain.GrazingPermit) {
                                this.GrazingPermit.GrazingArea = (0, MathUtil_1.round)(res.GeometryAreaHec, 2);
                            }
                            else if (this.PermitType == domain_1.PermitTypeDomain.HarvestingPermit) {
                                this.HarvestingPermit.HarvestingArea = (0, MathUtil_1.round)(res.GeometryAreaHec, 2);
                            }
                        }
                        if (res.Lga && res.LgaCode) {
                            this.Lga = res.Lga;
                            this.LgaCode = res.LgaCode;
                        }
                    }
                    resolve();
                });
            });
        }
        calculateFees() {
            if (this.PermitType == domain_1.PermitTypeDomain.TravelPermit) {
                this.TravelPermit.calculateFees();
            }
            else if (this.PermitType == domain_1.PermitTypeDomain.GrazingPermit) {
                this.GrazingPermit.calculateFees();
            }
        }
        getStockMinMaxValues() {
            const config = services_1.AppConfigManager.InstanceSync;
            const largeRule = config.getGrazingPermitStockFeeRule(this, domain_1.StockTypeDomain.Large);
            this.FeePerHeadPerWeekForLargeStockMinValue = largeRule.MinValue;
            this.FeePerHeadPerWeekForLargeStockMaxValue = largeRule.MaxValue;
            this.FeePerHeadPerWeekForLargeStockBatchSize = largeRule.BatchSize;
            const smallRule = config.getGrazingPermitStockFeeRule(this, domain_1.StockTypeDomain.Small);
            this.FeePerHeadPerWeekForSmallStockMinValue = smallRule.MinValue;
            this.FeePerHeadPerWeekForSmallStockMaxValue = smallRule.MaxValue;
            this.FeePerHeadPerWeekForSmallStockBatchSize = smallRule.BatchSize;
            console.info("getStockMinMaxValues", { largeRule, smallRule });
            this.validate(true);
        }
    }
    exports.Permit = Permit;
    Object.defineProperty(Permit, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Permit"
    });
    Object.defineProperty(Permit, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Permit"
    });
    Object.defineProperty(Permit, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "RefId", "ApplicationId", "ParentId", "AncestorId", "ConfigId", "SystemState", "PermitType", "Lga", "LgaCode", "LicenseStatus", "LicenseStatusReq", "LicenseStatusPrev", "LicenseStatusDate", "FeeApplicationRule", "FeeApplication", "FeePermitRule", "FeePermit", "FeeTotal", "FeeStateGov", "FinalFeeTotal", "FinalFeeStateGov", "CommentAppDecision", "CommentAdditionalCond", "SrnSegments", "AuditCreateUser", "AuditCreateDate", "AuditEditUser", "AuditEditDate"]
    });
    Object.defineProperty(Permit, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(Permit, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "ApplicationIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "ParentIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "AncestorIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "ConfigIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "SystemStateDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "SystemStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "PermitTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "PermitTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "LgaLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Permit, "LgaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "LgaCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(Permit, "LgaCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "LicenseStatusLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(Permit, "LicenseStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "LicenseStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "LicenseStatusReqLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(Permit, "LicenseStatusReqDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "LicenseStatusReqReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "LicenseStatusPrevLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(Permit, "LicenseStatusPrevDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "LicenseStatusPrevReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "LicenseStatusDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "FeeApplicationRuleDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "FeeApplicationRuleReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "FeeApplicationReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "FeePermitRuleDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "FeePermitRuleReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "FeePermitReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "FeeTotalReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "FeeStateGovReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "FinalFeeTotalReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "FinalFeeStateGovReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "CommentAppDecisionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2000
    });
    Object.defineProperty(Permit, "CommentAppDecisionTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter any supporting information relevant to the approval decision"
    });
    Object.defineProperty(Permit, "CommentAppDecisionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "CommentAdditionalCondLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2000
    });
    Object.defineProperty(Permit, "CommentAdditionalCondTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter any free-text additional conditions. After each condition, hit 'Enter' so that each new condition appears on a new line"
    });
    Object.defineProperty(Permit, "CommentAdditionalCondReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "SrnSegmentsLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 300
    });
    Object.defineProperty(Permit, "SrnSegmentsReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Permit, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Permit, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Permit, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Permit, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "ApplicationId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "ApplicationIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "ParentId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "ParentIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AncestorId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AncestorIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "ConfigId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "ConfigIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "SystemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "SystemStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "PermitType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "PermitTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "Lga", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LgaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LgaCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LgaCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LicenseStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LicenseStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LicenseStatusReq", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LicenseStatusReqError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LicenseStatusPrev", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LicenseStatusPrevError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LicenseStatusDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "LicenseStatusDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeeApplicationRule", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeeApplicationRuleError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeeApplication", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeeApplicationError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeePermitRule", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeePermitRuleError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeePermit", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeePermitError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeeTotal", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeeTotalError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeeStateGov", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FeeStateGovError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FinalFeeTotal", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FinalFeeTotalError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FinalFeeStateGov", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "FinalFeeStateGovError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "CommentAppDecision", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "CommentAppDecisionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "CommentAdditionalCond", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "CommentAdditionalCondError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "SrnSegments", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "SrnSegmentsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "GrazingAuthPermit", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "GrazingAuthPermitError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "TravelPermit", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "TravelPermitError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "StockSchedule", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "SelectedStockSchedule", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "StockScheduleError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "PermitLandtype", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "SelectedPermitLandtype", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "PermitLandtypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "GrazingPermit", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "GrazingPermitError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "PermitDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "SelectedPermitDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "PermitDocError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "PermitLicItem", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "SelectedPermitLicItem", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "PermitLicItemError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "HarvestingPermit", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "HarvestingPermitError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "PermitApplication", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Permit.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Permit.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Permit.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "License", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Permit.prototype, "ParentPermit", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], Permit.prototype, "StatusValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Permit.prototype, "IsUserPriviledgedToEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Permit.prototype, "IsAmendmentModeActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Permit.prototype, "IsReadOnly", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Permit.prototype, "IsActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Permit.prototype, "ApplicableDocumentTypes", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Permit.prototype, "openDocument", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Permit.prototype, "requestTmrPermitApproval", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Permit.prototype, "updatePermitOnGeometryChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Permit.prototype, "calculateFees", null);
});
